import { render } from "./payouts.vue?vue&type=template&id=67ceb793"
import script from "./payouts.vue?vue&type=script&lang=js"
export * from "./payouts.vue?vue&type=script&lang=js"

import "./payouts.vue?vue&type=style&index=0&id=67ceb793&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__